module.exports = __webpack_public_path__ + "img/生产协同能力较弱.ed83d32f.png";